import { RootState } from "@src/reducers/store";
import { setConnectedGatewaysWithMachinesListData } from "@src/reducers/gateways-machines-slice";
import { useDispatch, useSelector } from "react-redux";
import { useI18N } from "@src/language/language-context";

export const useGatewaysListHeaderHook = () => {
  const dispatch = useDispatch();
  const i18n = useI18N();
  const connectedGatewaysListData = useSelector(
    (state: RootState) => state.gatewaysMachinesSlice.connectedGatewaysListData,
  );

  const anySourcesVisible = connectedGatewaysListData.some(
    (gateway) => gateway.sources_visible === true,
  );

  const allCollapsed = connectedGatewaysListData.every(
    (gateway) => gateway.sources_visible === false,
  );

  const setSourcesVisibility = (sourcesVisible: boolean) => {
    dispatch(
      setConnectedGatewaysWithMachinesListData(
        connectedGatewaysListData.map((gateway) => ({
          ...gateway,
          sources_visible: sourcesVisible,
        })),
      ),
    );
  };

  const expandAllClickHandler = () => setSourcesVisibility(true);
  const closeAllClickHandler = () => setSourcesVisibility(false);

  const texts = {
    statusAndGateway: i18n("modules.gatewaysListHeader.statusAndGateway"),
    vendorId: i18n("modules.gatewaysListHeader.vendorId"),
    gatewayUuid: i18n("modules.gatewaysListHeader.gatewayUuid"),
    expandAll: i18n("modules.gatewaysListHeader.expandAll"),
    closeAll: i18n("modules.gatewaysListHeader.closeAll"),
  };

  return {
    anySourcesVisible,
    allCollapsed,
    texts,
    expandAllClickHandler,
    closeAllClickHandler,
  };
};
